import gql from "graphql-tag";

export const CORPORATE_QUERY = gql`
  query corporateChallenges($active: Boolean) {
    corporateChallenges(active: $active) {
      id
      title
      startDate
      endDate
      numberOfUsers
    }
  }
`;

export const CORPORATE_WITH_ENGAGMENT_QUERY = gql`
  query corporateChallenges($active: Boolean) {
    corporateChallenges(active: $active) {
      id
      title
      startDate
      endDate
      numberOfUsers
      engagedUsersRollingWeek
      engagedUsersRollingMonth
    }
  }
`;

export const CORPORATE_CHALLENGE_VIEW_QUERY = gql`
  query corporateChallenge($id: ID!) {
    corporateChallenge(id: $id) {
      id
      title
      startDate
      endDate
      users {
        id
        firstName
        lastName
        email
        employeeCode
        dots {
          exercise
          mindset
          nutrition
        }
        userProfile {
          id
          engagementScore
          incompleteTasks
          totalHydrationLogs
          totalMoodLogs
          totalSleepLogs
          gender
          coach {
            id
            firstName
            lastName
          }
          currentGroups {
            id
            title
          }
          currentChats {
            id
            title
          }
          currentBlocks {
            id
            title
          }
          nutritionCurrentBlock {
            id
            title
          }
        }
      }
    }
  }
`;
